import { createSlice } from '@reduxjs/toolkit';

import {
  open,
  removeDistrict,
  selectDistrict,
  switchNewMoscowDistrict,
  updateMeta,
} from '@/microfrontends/filters/shared/store/thunks/districtsPopup';

import { GEO_TAGS_MAP_DEFAULT } from '../../constants/geoTags';
import { JSON_QUERY_DEFAULT } from '../../constants/jsonQuery';
import { SEARCH_META_DEFAULT } from '../../constants/searchMeta';

import { type IDistrictsPopupState } from './types';

const districtsPopupInitialState: IDistrictsPopupState = {
  status: 'initial',
  isOpen: false,
  districts: [],
  jsonQuery: JSON_QUERY_DEFAULT,
  meta: {
    status: 'initial',
    data: SEARCH_META_DEFAULT,
  },
  geoTags: GEO_TAGS_MAP_DEFAULT,
};

export const districtsPopupSlice = createSlice({
  initialState: districtsPopupInitialState,
  name: 'districtsPopup',
  reducers: {
    close(state) {
      state.isOpen = false;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(open.pending, state => {
        state.status = 'loading';
        state.isOpen = true;
        state.districts = [];
        state.jsonQuery = JSON_QUERY_DEFAULT;
        state.meta = {
          status: 'initial',
          data: SEARCH_META_DEFAULT,
        };
        state.geoTags = GEO_TAGS_MAP_DEFAULT;
      })
      .addCase(open.fulfilled, (state, action) => {
        state.status = 'succeed';
        state.districts = action.payload.districts;
        state.jsonQuery = action.payload.jsonQuery;
        state.geoTags = action.payload.geoTags;
      })
      .addCase(open.rejected, state => {
        state.status = 'failed';
      })
      .addCase(selectDistrict.fulfilled, (state, action) => {
        state.geoTags.district = action.payload.geoTagsDistricts;
        state.jsonQuery = action.payload.jsonQuery;
      })
      .addCase(removeDistrict.fulfilled, (state, action) => {
        state.jsonQuery = action.payload;
      })
      .addCase(updateMeta.pending, state => {
        state.meta.status = 'loading';
      })
      .addCase(updateMeta.fulfilled, (state, action) => {
        state.meta.status = 'succeed';
        state.meta.data = action.payload;
      })
      .addCase(updateMeta.rejected, (state, action) => {
        if (action.payload === 'canceled') {
          return;
        }

        state.meta.status = 'failed';
      })
      .addCase(switchNewMoscowDistrict.fulfilled, (state, action) => {
        state.jsonQuery = action.payload;
      });
  },
});

export const { reducer: districtsPopupReducer, actions: districtsPopupActions } = districtsPopupSlice;
